import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
  return <section id="top" className="relative isolate mx-auto flex max-w-[1100px] flex-col items-center px-4 pb-20 pt-10 text-center sm:px-6 md:pb-28 md:pt-14" data-id="element-77" data-mp="23wme0vm64xcw">
      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.08,
      duration: 0.5
    }} className="mx-auto max-w-4xl text-4xl font-semibold leading-[1.08] tracking-[-0.035em] text-brand-text sm:text-5xl md:text-6xl" data-id="element-78" data-mp="2wj75rx6k3bgz">
        Los een heel jaar aan yogalessen op in slechts <span className="whitespace-nowrap italic text-brand-green" data-id="element-79" data-mp="2rrfo6c5dog2z">5 minuten</span>
      </motion.h1>
      <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.16,
      duration: 0.5
    }} className="mx-auto mt-6 max-w-2xl text-base leading-7 text-brand-gray sm:text-lg sm:leading-8" data-id="element-80" data-mp="3fh0an50qpvh0">
        Meer dan 1.200 docenten stopten al met improviseren. Kom bij elke les met alles klaar om te lesgeven, te verdiepen en te transformeren.
      </motion.p>
      <motion.div initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.24,
      duration: 0.55
    }} className="relative mx-auto mt-10 flex w-full max-w-4xl items-center justify-center border-y border-brand-creamDark/90 bg-white/30 px-4 py-6 sm:px-9 sm:py-8" data-id="element-81" data-mp="2p7eo28kkkyd9">
        <span aria-hidden="true" className="absolute inset-x-[18%] bottom-6 -z-10 h-14 rounded-full bg-brand-green/10 blur-2xl" data-id="element-82" data-mp="384pkzmiqbfpj" />
        <img src="https://cdn.magicpatterns.com/uploads/p3XwoLuGxxKuSJviuJtqG2/ChatGPT_Image_21_jul_2026,_11_25_59-Photoroom.png" alt="Yoga Klaar kit met vijf digitale yogagidsen, desktop, tablet en telefoon." className="h-auto w-full max-w-3xl object-contain" data-id="element-83" data-mp="336earaoiv36s" />
      </motion.div>
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.32,
      duration: 0.5
    }} className="mt-10 flex flex-col items-center" data-id="element-84" data-mp="38v5uh3jo3ur0">
        <CTAButton onClick={scrollToPricing} className="px-10 py-4 text-base" data-id="element-85" data-mp="3itlmr9ufla23">IK WIL DE YOGA KLAAR KIT</CTAButton>
        <p className="mt-4 text-sm font-medium text-brand-gray" data-id="element-86" data-mp="3mqrj39lzociw">Directe download <span aria-hidden="true" data-id="element-87" data-mp="3rrx9v1w39pps">·</span> Geen abonnement <span aria-hidden="true" data-id="element-88" data-mp="lcnvwkw57zm">·</span> Levenslange toegang</p>
      </motion.div>
    </section>;
}